import { render, staticRenderFns } from "./MessageAttachmentView.vue?vue&type=template&id=2f9b6e2c&scoped=true&"
import script from "./MessageAttachmentView.vue?vue&type=script&lang=ts&"
export * from "./MessageAttachmentView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageAttachmentView.vue?vue&type=style&index=0&id=2f9b6e2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b6e2c",
  null
  
)

export default component.exports